const getCookie = (name: string): string | null => {
    if (typeof document === "undefined") {
        return null;
    }
    const cookies = document.cookie ? document.cookie.split("; ") : [];
    for (const cookie of cookies) {
        const [key, ...value] = cookie.split("=");
        if (key === name) {
            return decodeURIComponent(value.join("="));
        }
    }
    return null;
};
const sessionKey: string | null = getCookie("sessionKey");
export const ENV = {
    encryptionKey: sessionKey ?? ""
};